import { render, staticRenderFns } from "./BotsTable.vue?vue&type=template&id=78a44f04&"
import script from "./BotsTable.vue?vue&type=script&lang=js&"
export * from "./BotsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports